import { Grid, styled, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import Logo from "../assets/logo.jpg";
import LogoutImage from "../assets/logout.png";
import { useNavigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const NavbarWrapper = styled(Grid)`
  border-bottom: 1px solid #000;
  padding: 13px 80px;
  background: #ec0000;
  color: #fff;
  font-family: verdana;
`;

function Navbar() {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(600));

  const { setAuth } = useAuth();

  const handleLogout = () => {
    setAuth({
      isAuthenticated: false,
      userEmail: null,
      roles: [],
      accessToken: null,
    });

    localStorage.clear();

    navigate("/login", { replace: true });
  };


  return (
    <NavbarWrapper container justifyContent={"center"} alignItems={"center"}>
      <Grid item container xs={10} justifyContent={isMobile && "center"}>
        <Grid item>
          <img
            src={Logo}
            alt="logo"
            height={80}
            width={90}
            style={{ borderRadius: "10px" }}
          />
        </Grid>
        <Grid item textAlign={"center"}>
          <h2>Dharanidara Spinning Mills Private Limited</h2>
          <p>
            Kanagagiri Village, Kakapalayam -637 504, Sankari Tk, Salem Dist.
          </p>
        </Grid>
      </Grid>
      <Grid
        item
        container
        xs={2}
        justifyContent={"flex-end"}
        onClick={() => handleLogout()}
        style={{ cursor: "pointer" }}
      >
        <img src={LogoutImage} alt="" height={30} width={30} />
      </Grid>
    </NavbarWrapper>
  );
}

export default Navbar;
